export default __webpack_public_path__ + "static/media/step2_act.93dd8b72.svg";